import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
// import "./App.scss";
const root = ReactDOM.createRoot(document.getElementById("root"));

const queryParams = new URLSearchParams(window.location.search);
const tenantId = queryParams.get("tenantId");

if (tenantId) {
  // If a tenantId is found in the URL, save it immediately.
  sessionStorage.setItem("tenantId", tenantId);
  console.log("tenantId from URL has been set in sessionStorage.");

  // Optional: Remove the query parameter from the URL for a cleaner look
  window.history.replaceState(null, "", window.location.pathname);
}
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
